<template>
  <div class="device-info-form">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
      :label-position="'left'">
      <div class="form_main">
        <div class="form_top_right">
          <el-form-item label="图片" prop="facilityImg">
            <el-upload class="avatar-uploader" ref="upload" :disabled="this.showFacility" :action="imgaction"
              :show-file-list="false" accept=".jpg,.gif,.png,.jpeg" :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload" :headers="{ Authorization: token }">
              <img v-if="ruleForm.facilityImg" :src="config.IMAGE_HOST + ruleForm.facilityImg" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="二维码类型" prop="oldCode">
            <el-radio-group :disabled="this.showFacility" v-model="ruleForm.oldCode">
              <el-radio :label="0">小</el-radio>
              <el-radio :label="1">大</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="系统编号" prop="facilityNum">
            <el-input class="inputWith" v-model="ruleForm.facilityNum" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="资产编号" prop="assetNum">
            <el-input class="inputWith" v-model="ruleForm.assetNum" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="设备型号" prop="facilityType">
            <el-select v-model="ruleForm.facilityType" :disabled="this.showFacility" placeholder="请选择"
              @change="handleSelect" filterable class="inputWith">
              <el-option class="inputWith" v-for="item in modelLibrary" :key="item.id" :label="item.modelName"
                :value="item.modelName">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-show="isFacilityType" style="padding-left: 90px; color: red; font-size: 12px; margin-bottom: 5px;">
            型号库未找到该型号,请重新选择!
          </div>
          <el-form-item label="设备名称" prop="facilityName">
            <el-input class="inputWith" v-model="ruleForm.facilityName" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="设备品牌" prop="facilityBrand">
            <el-input class="inputWith" v-model="ruleForm.facilityBrand" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" prop="typeId">
            <el-select class="inputWith" v-model="ruleForm.typeId" placeholder="请选择" :disabled="this.showFacility"
              clearable>
              <el-option class="inputWith" v-for="item in facilityList" :key="item.id" :label="item.facilityName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="购买时间" prop="buyTime">
            <el-date-picker :disabled="this.showFacility" v-model="ruleForm.buyTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="安装时间" prop="installationTime">
            <el-date-picker :disabled="installation" v-model="ruleForm.installationTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="资产归属" prop="assetOwnership">
            <el-select class="inputWith" v-model="ruleForm.supplierId" placeholder="请选择" :disabled="this.showFacility"
              clearable>
              <el-option class="inputWith" v-for="item in assetOwnershipList" :key="item.id" :label="item.supplierName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form_bottom_right">
          <el-form-item label="设备价值" prop="equipmentValue">
            <el-input class="inputWith" v-model="ruleForm.equipmentValue" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="生产厂家" prop="manufacturer">
            <el-input class="inputWith" v-model="ruleForm.manufacturer" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="核算科室" prop="checkDeskId">
            <el-cascader class="inputWith" filterable v-model="ruleForm.checkDeskId" :disabled="this.showFacility"
              :options="checkDeskList" :props="checkDeskKey" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="使用科室" prop="deskId">
            <el-cascader class="inputWith" filterable v-model="ruleForm.deskId" ref="cascaderDesk"
              :disabled="this.showFacility" :options="branchList" :props="cascaderKey" clearable
              @change="branchName"></el-cascader>
          </el-form-item>
          <el-form-item label="楼宇" prop="building">
            <el-select class="inputWith" v-model="ruleForm.building" placeholder="请选择" @change="selectBuilding"
              :disabled="this.showFacility" clearable>
              <el-option class="inputWith" v-for="item in buildingList" :key="item.id" :label="item.buildingName"
                v-model="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="楼层" prop="floor">
            <el-select class="inputWith" v-model="ruleForm.floor" placeholder="请选择" clearable
              :disabled="this.showFacility">
              <el-option class="inputWith" v-for="item in floorList" :key="item.id" :label="item.floorName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="房间号" prop="room">
            <el-input class="inputWith" v-model="ruleForm.room" placeholder="请输入房间号" clearable
              :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="设备状态" prop="state" v-if="isKong ? true : false">
            <el-select class="inputWith" v-model="ruleForm.state" placeholder="请选择" :disabled="this.showFacility"
              clearable>
              <el-option class="inputWith" v-for="item in stateList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="sn" prop="sn">
            <el-input class="inputWith" v-model="ruleForm.sn" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="ip/mac" prop="ipMac">
            <el-input class="inputWith" v-model="ruleForm.ipMac" :disabled="this.showFacility"></el-input>
          </el-form-item>
          <el-form-item label="盘点次数" prop="checkCount">
            <el-input class="inputWith" v-model="ruleForm.checkCount" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="最新盘点" prop="checkTime">
            <el-date-picker disabled="true" v-model="ruleForm.checkTime" type="date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="责任人" prop="liablePerson">
            <el-input class="inputWith" v-model="ruleForm.liablePerson" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="form_btn">
            <el-button type="primary" :disabled="!this.showFacility" @click="editFacility()">编辑</el-button>
            <el-button type="primary" :disabled="this.showFacility" @click="submitForm()">保存</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import config from "@/../config";
import dayjs from "dayjs";
let customerId = window.localStorage.getItem("customerId");

export default {
  name: 'deviceInfoForm',
  props: {
    facilityId: {
      type: String,
      default: ''
    },
    facilityNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isKong: false,
      action: "",
      facilityImg: "",
      branchList: [],
      showFacility: true,
      installation: true,
      imgaction: config.API_HOST + "/admin/common/upload",
      token: window.localStorage.getItem("token") || "",
      imageUrl: "",
      cascaderKey: {
        value: "id",
        label: "deskName",
        checkStrictly: true,
        emitPath: false,
      },
      checkDeskKey: {
        value: "id",
        label: "checkDeskName",
        checkStrictly: true,
        emitPath: false,
      },
      facilityList: [],
      assetOwnershipList: [],
      checkDeskList: [],
      stateList: [
        { value: 1, label: "库存中" },
        { value: 3, label: "已损坏" },
        { value: 4, label: "已报废" },
        { value: 6, label: "空码库" },
      ],
      ruleForm: {
        oldCode: 0,
        checkDeskId: "",
        id: "",
        facilityImg: "",
        facilityNum: "",
        assetNum: "",
        facilityType: "",
        facilityName: "",
        facilityBrand: "",
        typeId: "",
        buyTime: new Date(),
        installationTime: new Date(),
        assetOwnership: "",
        equipmentValue: "",
        manufacturer: "",
        deskId: "",
        installationSite: "",
        state: 1,
        sn: "",
        ipMac: "",
        checkCount: "",
        checkTime: "",
        liablePerson: "",
        building: "",
        room: "",
        floor: "",
      },
      rules: {
        assetNum: [{ required: true, message: "请输入资产编号", trigger: "blur" }],
        facilityName: [{ required: true, message: "请输入资产名称", trigger: "blur" }],
        assetOwnership: [{ required: true, message: "请输入资产归属", trigger: "blur" }],
        typeId: [{ required: true, message: "请输入资产类型", trigger: "blur" }],
        sn: [{ required: true, message: "请输入sn", trigger: "blur" }],
      },
      floorList: [],
      buildingList: [],
      modelLibrary: [],
      isFacilityType: true,
      config: config,
    };
  },
  watch: {
    facilityId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.load(val);
        }
      }
    }
  },
  created() {
    this.getCheckDeskList();
    this.loadLevelData();
    this.loadAssetOwnershipList();
    this.getBranch();
    this.getBuilding();
    this.getModelLibraryList();
  },
  methods: {
    branchName(e) {
      if (this.$refs.cascaderDesk && this.$refs.cascaderDesk.getCheckedNodes()[0]) {
        this.ruleForm.installationSite = this.$refs.cascaderDesk.getCheckedNodes()[0].data.address;
      }
    },
    async getBranch() {
      let d = {};
      let res = await $utils.api.load("admin/system/desk/list", d, "get");
      if (res.code == 200) {
        this.branchList = res.rows;
      }
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        let data = res.rows;
        if (data && data.length > 0) {
          const processedRows = data.map((item) => ({
            ...item,
            disabled: true,
          }));
          this.checkDeskList = processedRows;
        } else {
          this.checkDeskList = [];
        }
      }
    },
    editFacility() {
      if (this.ruleForm.facilityName == null) {
        this.installation = false;
      }
      this.showFacility = false;
    },
    loadLevelData() {
      let q = {};
      $utils.api.load("/admin/system/facilityType/selectList", q).then((res) => {
        if (res && res.rows) {
          this.facilityList = res.rows;
        }
      });
    },
    loadAssetOwnershipList() {
      let q = { customerId: Number(customerId) };
      $utils.api.load("/admin/system/supplier/selectList", q).then((res) => {
        if (res && res.rows) {
          this.assetOwnershipList = res.rows;
        }
      });
    },
    async load(id) {
      let res = await $utils.api.load(`/admin/system/facility/${id}`, {}, "get");
      if (res.data) {
        this.ruleForm = res.data;
        this.ruleForm.facilityImg = res.data.facilityImg;
        this.getModelLibraryList("edit");
        if (res.data.building) {
          this.getFloor(res.data.building);
        }
      }
    },
    handleAvatarSuccess(res, file) {
      this.facilityImg = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.ruleForm.facilityImg = res.url;
      }
    },
    beforeAvatarUpload(file) {
      let isImg = true;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isJPEG && !isPNG && !isGIF) {
        this.$message.error("上传头像图片只能是 JPG,JPEG,PNG,GIF 格式!");
        isImg = false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isImg && isLt2M;
    },
    async submitForm() {
      if (!this.ruleForm.assetNum) {
        $utils.toast.error("请填写资产编号");
        return;
      }
      if (!this.ruleForm.facilityName) {
        $utils.toast.error("请填写资产名称");
        return;
      }
      if (!this.ruleForm.supplierId) {
        $utils.toast.error("请选择资产归属");
        return;
      }
      if (!this.ruleForm.typeId) {
        $utils.toast.error("请选择资产类型");
        return;
      }
      if (!this.ruleForm.sn) {
        $utils.toast.error("请填写sn");
        return;
      }
      if (this.ruleForm.buyTime) {
        let buyTime = new Date(this.ruleForm.buyTime);
        this.ruleForm.buyTime = dayjs(buyTime).format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.ruleForm.installationTime) {
        let installationTime = new Date(this.ruleForm.installationTime);
        this.ruleForm.installationTime = dayjs(installationTime).format("YYYY-MM-DD HH:mm:ss");
      }
      let res = await $utils.api.load("/admin/system/facility", this.ruleForm, "put");

      if (res.code == 200) {
        $utils.toast.success("保存成功");
        this.showFacility = true;
        this.load(this.facilityId);
      } else {
        $utils.toast.error("保存失败");
      }
    },
    async getBuilding() {
      let d = {};
      let res = await $utils.api.load("admin/system/building/list", d, "get");
      if (res.code == 200) {
        this.buildingList = res.rows;
      }
    },
    async getFloor(e) {
      let d = { buildingId: e };
      let res = await $utils.api.load("admin/system/floor/list", d, "get");
      if (res.code == 200) {
        this.floorList = res.rows;
      }
    },
    selectBuilding(e) {
      this.getFloor(e);
    },
    async getModelLibraryList(value) {
      let d = {};
      let res = await $utils.api.load("/admin/system/modelLibrary/listSelect", d, "get");
      if (res.code == 200) {
        let list = res.rows;
        this.modelLibrary = list;
        if (value == "edit" && this.ruleForm.facilityType) {
          list.forEach((item) => {
            if (item.modelName == this.ruleForm.facilityType) {
              this.isFacilityType = false;
            }
          });
        }
      }
    },
    handleSelect(items) {
      this.modelLibrary.forEach((item) => {
        if (item.modelName == items) {
          this.ruleForm.facilityType = item.modelName;
          this.ruleForm.facilityBrand = item.brandName;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.device-info-form {
  max-width: 1200px;
  margin: 0 auto;

  /deep/ .is-error {
    margin-bottom: 20px !important;
  }

  .inputWith {
    width: 300px;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff;
  }

  /deep/ .el-form-item {
    margin-bottom: 8px;
  }

  .avatar-uploader {
    height: 90px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .form_main {
    display: flex;
    justify-content: space-around;
    gap: 40px;
  }

  .form_top_right,
  .form_bottom_right {
    flex: 1;
    min-width: 0;
  }

  .form_btn {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
